<template>
  <div data-test-id="top-navbar" :class="{ 'kk-navigation': true, 'kk-content-focused': contentFocused }">
    <router-link to="/designs" class="kk-navigation__links" @click="closeDesign">
      <img :src="require('@/assets/Logo1.svg')" class="kk-navigation__logo-img" />
    </router-link>

    <smart-search />

    <div style="flex-grow: 1"></div>

    <custom-button v-if="mybusiness" button-class="btn kk-navigation__mybusiness-btn" @click="bussinessDialog = true">
      <custom-icon class-name="icon-office-building-cog" icon-color="inherit" />
    </custom-button>

    <div v-if="user" class="kk-navigation__profile-info" data-test-id="profile-section" @click="toggleProfileDialog">
      <div :title="user.email">
        <img :src="require('@/assets/avatar.png')" class="kk-navigation__profile-img" />
        <i class="icon-menu-down"></i>
      </div>
    </div>

    <profile v-if="profileDialog" @close-popup="profileDialog = false" />

    <!-- config popup -->
    <custom-modal v-if="bussinessDialog" modal-width="40rem" @close="bussinessDialog = false">
      <template #body>
        <mybusiness @close-popup="bussinessDialog = false" />
      </template>
    </custom-modal>
  </div>
</template>

<script>
import Profile from "./Profile.vue";
import SmartSearch from "../process-design/smart-search/SmartSearch.vue";
import CustomModal from "../commons/CustomModal.vue";
import CustomButton from "../commons/CustomButton.vue";
import CustomIcon from "../commons/CustomIcon.vue";
import Mybusiness from "./MyBusiness.vue";

export default {
  components: {
    CustomModal,
    SmartSearch,
    Profile,
    CustomButton,
    CustomIcon,
    Mybusiness,
  },
  computed: {
    mybusiness() {
      return this.$store.state.subscription.action.status.loading == "loaded";
    },
    user() {
      return this.$store.state.authUser;
    },
    contentFocused() {
      return this.$store.state.pdesign.contentFocused;
    },
    profileDialog: {
      get: function () {
        return this.$store.state.showProfileDialog;
      },
      set: function (val) {
        this.$store.dispatch("toggleProfileDialog", val);
      },
    },
    bussinessDialog: {
      get: function () {
        return this.$store.state.showBussinessDialog;
      },
      set: function (val) {
        this.$store.dispatch("toggleBussinessDialog", val);
      },
    },
  },
  mounted() {
    this.$store.dispatch("subscription/load").catch((err) => {});
  },
  methods: {
    toggleProfileDialog() {
      this.profileDialog = !this.profileDialog;
    },
    closeModal() {
      this.profileDialog = !this.profileDialog;
    },
    signOut() {
      this.$store.dispatch("smartSearch/searchAndCall", { value: "logout", i18n: this.$i18n });
    },
    closeDesign() {
      this.$store.dispatch("closeDesign");
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.kk-navigation {
  display: flex;
  align-items: center;
  background-color: @kk-color-primary-blue;
  color: @kk-color-light-white;
  height: 4rem;
  margin: -0.5rem;
  margin-bottom: 0;
  position: relative;

  &__logo-img {
    width: 4.3rem;
    height: 4.3rem;
    margin: 0 0.5rem;
    margin-right: 14.5rem;
  }

  &__links {
    display: flex;
    align-items: center;
    color: @kk-color-light-white;
    text-decoration: none;
    padding: 1rem;
    transition: all 0.3s;

    &:hover:not(:first-child) {
      background-color: lighten(@kk-color-primary-blue, 10%);
      position: relative;
    }
  }

  &__app-name {
    font-size: 1.25rem;
    margin-left: 0.5rem;
  }

  &__profile-info {
    div {
      display: flex;
      align-items: center;
    }
    display: flex;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    margin-right: 1.2rem !important;

    i {
      font-size: 1.4rem;
    }
  }

  &__profile-img {
    height: 35px;
    border-radius: 100%;
  }

  &__profile-username {
    padding-left: 0.5rem;
  }

  &__profile-info,
  &__mybusiness-btn,
  &__logout-btn {
    color: @kk-color-light-white !important;
  }
  &__logout-btn {
    margin-right: 0.75rem;
  }
  &__profile-info {
    margin: 0 0.5rem;
  }

  &.kk-content-focused {
    display: none;
  }
}
</style>
